/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The type of a path segment in a bucket path partition spec
*/
export enum SegmentType {
  SEGMENT_TYPE_STRING = 'STRING',
  SEGMENT_TYPE_WILDCARD = 'WILDCARD',
  SEGMENT_TYPE_PARTITION = 'PARTITION'
}
